import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { logoutUser } from '../store/authSlice';

function Navbar() {
    const { user, isAuthenticated } = useSelector((state) => state.auth);

    const dispatch = useDispatch();

    const handleLogout = () => {
        dispatch(logoutUser());
    }

    const [openMenus, setOpenMenus] = useState({
        userMenu: false,
        notificationsMenu: false,
        messagesMenu: false,
    });

    const toggleMenu = (menuKey) => {
        setOpenMenus((prev) => {
            // Crée un nouvel état avec tous les menus fermés
            const newState = {
                userMenu: false,
                notificationsMenu: false,
                messagesMenu: false,
            };

            // Ouvre ou ferme le menu ciblé
            return {
                ...newState,
                [menuKey]: !prev[menuKey], // Inverse l'état du menu ciblé
            };
        });
    };

    return (

        <div id='navbar' className="md:top-0 md:z-20 md:fixed flex flex-row flex-wrap items-center border-gray-300 bg-white p-6 border-b md:w-full">

            {/* logo */}
            <div className="flex flex-row flex-none items-center w-56">
                <img src="assets/img/logo.png" className="flex-none w-10" />
                <strong className="flex-1 ml-1 capitalize">MEZA NGEMA</strong>

                <button id="sliderBtn" className="md:block text-right flex-none hidden text-gray-900">
                    <i className="fa-list-ul fad"></i>
                </button>
            </div>
            {/* end logo */}

            {/* navbar content toggle */}
            <button id="navbarToggle" className="md:block right-0 md:fixed hidden mr-6">
                <i className="fa-chevron-double-down fad"></i>
            </button>
            {/* end navbar content toggle */}

            {/* navbar content */}
            <div id="navbar" className="md:top-0 md:left-0 md:fixed flex flex-row md:flex-col flex-wrap flex-1 justify-between items-center md:items-center md:border-gray-200 md:hidden md:bg-white md:mt-16 md:p-10 pl-3 md:border-t md:border-b md:w-full animated">
                {/* left */}
                <div className="md:flex md:flex-row md:justify-evenly md:border-gray-200 md:mb-10 md:pb-10 md:border-b md:w-full text-gray-600">
                    <a className="mr-2 hover:text-gray-900 transition duration-500 ease-in-out" href="#" title="email"><i className="fa-envelope-open-text fad"></i></a>
                    <a className="mr-2 hover:text-gray-900 transition duration-500 ease-in-out" href="#" title="email"><i className="fa-comments-alt fad"></i></a>
                    <a className="mr-2 hover:text-gray-900 transition duration-500 ease-in-out" href="#" title="email"><i className="fa-check-circle fad"></i></a>
                    <a className="mr-2 hover:text-gray-900 transition duration-500 ease-in-out" href="#" title="email"><i className="fa-calendar-exclamation fad"></i></a>
                </div>
                {/* end left */}

                {/* right */}
                <div className="flex flex-row-reverse items-center">

                    {/* user */}
                    <div className="relative md:static dropdown">

                        <button
                            onClick={() => toggleMenu("userMenu")}
                            className="flex flex-wrap items-center focus:shadow-outline focus:outline-none menu-btn">
                            <div className="rounded-full w-8 h-8 overflow-hidden">
                                <img className="w-full h-full object-cover" src="assets/img/user.svg" />
                            </div>

                            <div className="flex ml-2 capitalize">
                                <h1 className="m-0 p-0 font-semibold text-gray-800 text-sm leading-none">{user.username}</h1>
                                <i className="ml-2 text-xs leading-none fa-chevron-down fad"></i>
                            </div>
                        </button>


                        {openMenus.userMenu && (

                            <div className="right-0 z-20 absolute bg-white shadow-md mt-6 md:mt-10 py-2 rounded w-44 md:w-full text-gray-500 animated fadeIn faster menunav">

                                {/* item */}
                                <a className="block bg-white hover:bg-gray-200 px-4 py-2 font-medium text-sm hover:text-gray-900 capitalize tracking-wide transition-all duration-300 ease-in-out"
                                    href="/profil">
                                    <i className="mr-1 text-xs fa-user-edit fad"></i>
                                    Éditer mon profil
                                </a>
                                {/* end item */}

                                {/* item */}
                                <a className="block bg-white hover:bg-gray-200 px-4 py-2 font-medium text-sm hover:text-gray-900 capitalize tracking-wide transition-all duration-300 ease-in-out" href="#">
                                    <i className="mr-1 text-xs fa-inbox-in fad"></i>
                                    Mes messages
                                </a>
                                {/* end item */}

                                {/* item */}
                                <a className="block bg-white hover:bg-gray-200 px-4 py-2 font-medium text-sm hover:text-gray-900 capitalize tracking-wide transition-all duration-300 ease-in-out" href="#">
                                    <i className="mr-1 text-xs fa-badge-check fad"></i>
                                    Mes taches
                                </a>
                                {/* end item */}


                                <hr />

                                {/* item */}
                                <a className="block bg-white hover:bg-gray-200 px-4 py-2 font-medium text-sm hover:text-gray-900 capitalize tracking-wide transition-all duration-300 cursor-pointer ease-in-out"
                                    onClick={handleLogout}>
                                    <i className="mr-1 text-xs fa-user-times fad"></i>
                                    Déconnexion
                                </a>
                                {/* end item */}

                            </div>
                        )}
                    </div>
                    {/* end user */}

                    {/* notifcation */}
                    <div className="relative md:static mr-5 dropdown">

                        <button
                            onClick={() => toggleMenu("notificationsMenu")}
                            className="m-0 p-0 text-gray-500 hover:text-gray-900 focus:text-gray-900 transition-all duration-300 ease-in-out focus:outline-none menunav-btn">
                            <i className="fa-bells fad"></i>
                        </button>

                        {openMenus.notificationsMenu && (

                            <div className="right-0 md:right-0 z-20 absolute bg-white shadow-md mt-5 py-2 rounded w-84 md:w-full animated fadeIn faster menunav">
                                {/* top */}
                                <div className="flex flex-row justify-between items-center px-4 py-2 font-semibold text-sm capitalize">
                                    <h1>notifications</h1>
                                    <div className="bg-teal-100 px-1 border border-teal-200 rounded text-teal-500 text-xs">
                                        <strong>5</strong>
                                    </div>
                                </div>
                                <hr />
                                {/* end top */}

                                {/* body */}

                                {/* item */}
                                <a className="flex flex-row justify-start items-center bg-white hover:bg-gray-200 px-4 py-4 font-medium text-sm capitalize tracking-wide transition-all duration-300 ease-in-out" href="#">

                                    <div className="border-gray-300 bg-gray-100 mr-3 px-3 py-2 border rounded">
                                        <i className="text-sm fa-birthday-cake fad"></i>
                                    </div>

                                    <div className="flex flex-rowbg-green-100 flex-1">
                                        <div className="flex-1">
                                            <h1 className="font-semibold text-sm">poll..</h1>
                                            <p className="text-gray-500 text-xs">text here also</p>
                                        </div>
                                        <div className="text-right text-gray-500 text-xs">
                                            <p>4 min ago</p>
                                        </div>
                                    </div>

                                </a>
                                <hr />
                                {/* end item */}

                                {/* item */}
                                <a className="flex flex-row justify-start items-center bg-white hover:bg-gray-200 px-4 py-4 font-medium text-sm capitalize tracking-wide transition-all duration-300 ease-in-out" href="#">

                                    <div className="border-gray-300 bg-gray-100 mr-3 px-3 py-2 border rounded">
                                        <i className="text-sm fa-user-circle fad"></i>
                                    </div>

                                    <div className="flex flex-rowbg-green-100 flex-1">
                                        <div className="flex-1">
                                            <h1 className="font-semibold text-sm">mohamed..</h1>
                                            <p className="text-gray-500 text-xs">text here also</p>
                                        </div>
                                        <div className="text-right text-gray-500 text-xs">
                                            <p>78 min ago</p>
                                        </div>
                                    </div>

                                </a>
                                <hr />
                                {/* end item */}

                                {/* item */}
                                <a className="flex flex-row justify-start items-center bg-white hover:bg-gray-200 px-4 py-4 font-medium text-sm capitalize tracking-wide transition-all duration-300 ease-in-out" href="#">

                                    <div className="border-gray-300 bg-gray-100 mr-3 px-3 py-2 border rounded">
                                        <i className="text-sm fa-images fad"></i>
                                    </div>

                                    <div className="flex flex-rowbg-green-100 flex-1">
                                        <div className="flex-1">
                                            <h1 className="font-semibold text-sm">new imag..</h1>
                                            <p className="text-gray-500 text-xs">text here also</p>
                                        </div>
                                        <div className="text-right text-gray-500 text-xs">
                                            <p>65 min ago</p>
                                        </div>
                                    </div>

                                </a>
                                <hr />
                                {/* end item */}

                                {/* item */}
                                <a className="flex flex-row justify-start items-center bg-white hover:bg-gray-200 px-4 py-4 font-medium text-sm capitalize tracking-wide transition-all duration-300 ease-in-out" href="#">

                                    <div className="border-gray-300 bg-gray-100 mr-3 px-3 py-2 border rounded">
                                        <i className="fa-alarm-exclamation text-sm fad"></i>
                                    </div>

                                    <div className="flex flex-rowbg-green-100 flex-1">
                                        <div className="flex-1">
                                            <h1 className="font-semibold text-sm">time is up..</h1>
                                            <p className="text-gray-500 text-xs">text here also</p>
                                        </div>
                                        <div className="text-right text-gray-500 text-xs">
                                            <p>1 min ago</p>
                                        </div>
                                    </div>

                                </a>
                                {/* end item */}


                                {/* end body */}

                                {/* bottom */}
                                <hr />
                                <div className="mt-2 px-4 py-2">
                                    <a href="#" className="block border-gray-300 p-1 border rounded text-center text-xs hover:text-teal-500 uppercase transition-all duration-500 ease-in-out">
                                        view all
                                    </a>
                                </div>
                                {/* end bottom */}
                            </div>
                        )}
                    </div>
                    {/* end notifcation */}

                    {/* messages */}
                    <div className="relative md:static mr-5 dropdown">

                        <button
                            onClick={() => toggleMenu('messagesMenu')}
                            className="m-0 p-0 text-gray-500 hover:text-gray-900 focus:text-gray-900 transition-all duration-300 ease-in-out focus:outline-none navmenu-btn">
                            <i className="fa-comments fad"></i>
                        </button>

                        {openMenus.messagesMenu && (

                            <div className="right-0 md:right-0 z-20 absolute bg-white shadow-md mt-5 py-2 rounded w-84 md:w-full animated fadeIn faster navmenu">
                                {/* top */}
                                <div className="flex flex-row justify-between items-center px-4 py-2 font-semibold text-sm capitalize">
                                    <h1>messages</h1>
                                    <div className="bg-teal-100 px-1 border border-teal-200 rounded text-teal-500 text-xs">
                                        <strong>3</strong>
                                    </div>
                                </div>
                                <hr />
                                {/* end top */}

                                {/* body */}

                                {/* item */}
                                <a className="flex flex-row justify-start items-center bg-white hover:bg-gray-200 px-4 py-4 font-medium text-sm capitalize tracking-wide transition-all duration-300 ease-in-out" href="#">

                                    <div className="border-gray-300 bg-gray-100 mr-3 border rounded-full w-10 h-10 overflow-hidden">
                                        <img className="w-full h-full object-cover" src="assets/img/user1.jpg" alt="" />
                                    </div>

                                    <div className="flex flex-rowbg-green-100 flex-1">
                                        <div className="flex-1">
                                            <h1 className="font-semibold text-sm">mohamed said</h1>
                                            <p className="text-gray-500 text-xs">yeah i know</p>
                                        </div>
                                        <div className="text-right text-gray-500 text-xs">
                                            <p>4 min ago</p>
                                        </div>
                                    </div>

                                </a>
                                <hr />
                                {/* end item */}

                                {/* item */}
                                <a className="flex flex-row justify-start items-center bg-white hover:bg-gray-200 px-4 py-4 font-medium text-sm capitalize tracking-wide transition-all duration-300 ease-in-out" href="#">

                                    <div className="border-gray-300 bg-gray-100 mr-3 border rounded-full w-10 h-10 overflow-hidden">
                                        <img className="w-full h-full object-cover" src="assets/img/user2.jpg" alt="" />
                                    </div>

                                    <div className="flex flex-rowbg-green-100 flex-1">
                                        <div className="flex-1">
                                            <h1 className="font-semibold text-sm">sull goldmen</h1>
                                            <p className="text-gray-500 text-xs">for sure</p>
                                        </div>
                                        <div className="text-right text-gray-500 text-xs">
                                            <p>1 day ago</p>
                                        </div>
                                    </div>

                                </a>
                                <hr />
                                {/* end item */}

                                {/* item */}
                                <a className="flex flex-row justify-start items-center bg-white hover:bg-gray-200 px-4 py-4 font-medium text-sm capitalize tracking-wide transition-all duration-300 ease-in-out" href="#">

                                    <div className="border-gray-300 bg-gray-100 mr-3 border rounded-full w-10 h-10 overflow-hidden">
                                        <img className="w-full h-full object-cover" src="assets/img/user3.jpg" alt="" />
                                    </div>

                                    <div className="flex flex-rowbg-green-100 flex-1">
                                        <div className="flex-1">
                                            <h1 className="font-semibold text-sm">mick</h1>
                                            <p className="text-gray-500 text-xs">is typing ....</p>
                                        </div>
                                        <div className="text-right text-gray-500 text-xs">
                                            <p>31 feb</p>
                                        </div>
                                    </div>

                                </a>
                                {/* end item */}


                                {/* end body */}

                                {/* bottom */}
                                <hr />
                                <div className="mt-2 px-4 py-2">
                                    <a href="#" className="block border-gray-300 p-1 border rounded text-center text-xs hover:text-teal-500 uppercase transition-all duration-500 ease-in-out">
                                        view all
                                    </a>
                                </div>
                                {/* end bottom */}
                            </div>
                        )}
                    </div>
                    {/* end messages */}


                </div>
                {/* end right */}
            </div>
            {/* end navbar content */}

        </div>
    )
}

export default Navbar